import {
  ConfirmModal,
  TitleAndTable,
  WarningModal
} from "components/Common"
import {
  convertDateFormat,
  insertUrlParam,
  onDelete,
  onDeleteToggle,
  selectCheckboxHandler
} from "helpers/utilities"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import { ModuleIds, SAMPLES_DELIVERY_TYPE } from "constant"
import { exportDeliveryList } from "helpers/app-backend"
import { getUrlParams } from "helpers/utilities"
import { isEmpty } from "lodash"
import { withTranslation } from "react-i18next"
import {
  addDelivery,
  addNewFile,
  deleteDeliveries,
  getDeliveries,
  getDeliveryDetail,
  resetDeliveriesSearchQuery,
  updateDelivery,
} from "store/actions"
import DeliveryReceiveTable from "./DeliveryReceiptTable"

const RESOURCE = ModuleIds.DeliveryReceive

const DeliveryReceipt = ({
  deliveries,
  paging,
  onGetDeliveries,
  onDeleteDeliveries,
  onResetDeliveriesSearchQuery,
  onGetDeliveryDetail,
  loadingDeliveries,
  updatedDeliveriesTime,
  t,
}) => {
  const [confirmModal, setConfirmModal] = useState(false)
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(true)
  const [row, setRow] = useState({})
  const [rowDelete, setRowDelete] = useState({})
  const [rows, setRows] = useState([])
  const [warningModal, setWarningModal] = useState(false)
  const [warningReport, setWarningReportModal] = useState(false)

  const toggle = () => {
    setModal(prev => !prev)
  }

  const onEditHandler = (e, paramId) => {
    const id = paramId || row?.id
    if (id) {
      onGetDeliveryDetail(id)
      setIsEdit(true)
      toggle()
    } else setWarningModal(true)
  }

  const resetState = () => {
    setRows([])
    setRow({})
  }

  const onDeleteToggleHandler = (e, param) => {
    onDeleteToggle({
      rows,
      row: param || rowDelete,
      setConfirmModal,
      setWarningModal,
      setRowDelete,
    })
    if (confirmModal) setRowDelete({})
  }

  const onDeleteMultipleRows = rowsState => {
    onDeleteDeliveries({
      deliveries: rowsState, callback: () => {
        resetState()
        onRefreshAfterAction()
      }
    })
  }

  const onDeleteSingleRow = rowsState => {
    onDeleteDeliveries({
      deliveries: rowsState,
      callback: () => {
        setRows(prev => prev.filter(x => x.id !== rowDelete.id))
        onRefreshAfterAction()
      },
    })
    setRowDelete({})
    setRow({})
  }

  const onDeleteDeliveryHandler = () => {
    onDelete({
      rowDelete,
      rows,
      onDeleteSingleRow,
      onDeleteMultipleRows,
    })
    setConfirmModal(false)
  }

  const onSelectCheckbox = (row, isSelected) => {
    const { rowsState, currentRow } = selectCheckboxHandler(
      rows,
      row,
      isSelected
    )
    setRows(rowsState)
    setRow(currentRow)
  }

  const onSelectAllCheckbox = rows => {
    setRows(rows)
    if (rows.length < 1) setRow({})
    else setRow(rows[rows.length - 1])
  }
  const onGetDeliveryList = (payload) => {
    const param = { ...payload }
    delete param.type
    insertUrlParam(payload)
    onGetDeliveries({ ...payload, type: SAMPLES_DELIVERY_TYPE.DeliveryAndReceipt })
  }

  const fetchDeliveries = () => {
    onGetDeliveryList({
      page: 1, size: 10,
      start: convertDateFormat(new Date(), "YYYY-MM-DD"),
      end: convertDateFormat(new Date(), "YYYY-MM-DD"),
      type: SAMPLES_DELIVERY_TYPE.DeliveryAndReceipt
    })
  }

  const fetchDeliveriesCurrentPage = () => {
    onGetDeliveryList({ type: SAMPLES_DELIVERY_TYPE.DeliveryAndReceipt })
  }

  /** Table methods */
  const onRefreshHandler = () => {
    resetState()
    fetchDeliveries()
  }

  const onRefreshAfterAction = () => {
    resetState()
    fetchDeliveriesCurrentPage()
  }

  const onSearch = searchText => {
    onGetDeliveryList({ page: 1, search: searchText, type: SAMPLES_DELIVERY_TYPE.DeliveryAndReceipt })
  }

  const onSizePerPageChange = size => {
    onGetDeliveryList({ page: 1, size, type: SAMPLES_DELIVERY_TYPE.DeliveryAndReceipt })
  }

  const onPageChange = page => {
    onGetDeliveryList({ page, type: SAMPLES_DELIVERY_TYPE.DeliveryAndReceipt })
  }

  const onSubmitFilter = values => {
    onGetDeliveryList({ page: 1, ...values, type: SAMPLES_DELIVERY_TYPE.DeliveryAndReceipt })
  }

  const onSortHandler = (field, order) => {
    const sortString = `${field}:${order}`
    onGetDeliveryList({ page: 1, sort: sortString, type: SAMPLES_DELIVERY_TYPE.DeliveryAndReceipt })
  }

  useEffect(() => {
    onResetDeliveriesSearchQuery()
  }, [])

  useEffect(() => {
    let params = getUrlParams();
    if (!isEmpty(params)) {
      onGetDeliveryList(params)
    } else {
      fetchDeliveries()
    }
  }, [])

  const onDeliveryListExportHandler = async () => {
    let params = getUrlParams()
    const fileData = await exportDeliveryList({ ...params, type: SAMPLES_DELIVERY_TYPE.DeliveryAndReceipt })
    const blob = new Blob([fileData])
    saveAs(blob, 'Danh_sach_phieu_giao_nhan_mau.xlsx')
  }

  return (
    <React.Fragment>
      <TitleAndTable
        external
        table={() => (
          <DeliveryReceiveTable
            deliveries={deliveries}
            onSelect={onSelectCheckbox}
            onSelectAll={onSelectAllCheckbox}
            onSearch={onSearch}
            onSort={onSortHandler}
            onRefresh={onRefreshHandler}
            onPageChange={onPageChange}
            paging={paging}
            onSizePerPageChange={onSizePerPageChange}
            onSubmitFilter={onSubmitFilter}
            onEdit={onEditHandler}
            onDelete={onDeleteToggleHandler}
            loading={loadingDeliveries}
            updatedTime={updatedDeliveriesTime}
            onDeliveryListExport={onDeliveryListExportHandler}
          />
        )}
        resource={RESOURCE}
        onEdit={onEditHandler}
        onDelete={onDeleteToggleHandler}
        title={t("testRequestPage:Process management")}
        subtitle={t("Delivery Receipt List")}
      />

      <WarningModal
        modal={warningModal}
        onToggle={() => setWarningModal(prev => !prev)}
        message={t("message:SelectRowWarning")}
      />
      <WarningModal
        modal={warningReport}
        onToggle={() => setWarningReportModal(prev => !prev)}
        message={t("message:ReportWarning")}
      />
      <ConfirmModal
        modal={confirmModal}
        title={`${t("common:Delete")} ${t("Sample Delivery")}`}
        message={t("message:DeleteConfirm")}
        onToggle={onDeleteToggleHandler}
        onDelete={onDeleteDeliveryHandler}
      />
    </React.Fragment>
  )
}

DeliveryReceipt.propTypes = {
  deliveries: PropTypes.array,
  onGetDeliveryDetail: PropTypes.func,
  onGetDeliveries: PropTypes.func,
  onAddNewDelivery: PropTypes.func,
  onUpdateDelivery: PropTypes.func,
  onDeleteDeliveries: PropTypes.func,
  onResetDeliveriesSearchQuery: PropTypes.func,
  paging: PropTypes.object,
  loadingDeliveries: PropTypes.bool,
  updatedDeliveriesTime: PropTypes.any,
  t: PropTypes.any,
}

const mapStateToProps = ({ sampleDelivery }) => {
  return {
    deliveries: sampleDelivery.deliveries,
    delivery: sampleDelivery.delivery,
    paging: sampleDelivery.paging,
    loadingDeliveries: sampleDelivery.loadingDeliveries,
    updatedDeliveriesTime: sampleDelivery.updateDeliveriesTime,
  }
}

const mapDispatchToProps = dispatch => ({
  onGetDeliveries: payload => dispatch(getDeliveries(payload)),
  onAddNewDelivery: (delivery, history, resource) =>
    dispatch(addDelivery(delivery, history, resource)),
  onUpdateDelivery: delivery => dispatch(updateDelivery(delivery)),
  onDeleteDeliveries: deliveries => dispatch(deleteDeliveries(deliveries)),
  onGetDeliveryDetail: deliveryId => dispatch(getDeliveryDetail(deliveryId)),
  onResetDeliveriesSearchQuery: () => dispatch(resetDeliveriesSearchQuery()),
  onAddNewFile: (data, callback) =>
    dispatch(addNewFile(data, callback)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(withTranslation(["deliveryPage", "message", "testRequestPage"])(DeliveryReceipt))
)
